import { render, staticRenderFns } from "./customCategoriesDialog.vue?vue&type=template&id=329d17d6&scoped=true"
import script from "./customCategoriesDialog.vue?vue&type=script&lang=js"
export * from "./customCategoriesDialog.vue?vue&type=script&lang=js"
import style0 from "./customCategoriesDialog.vue?vue&type=style&index=0&id=329d17d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d17d6",
  null
  
)

export default component.exports